import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import RequestNavbar from "../../components/RequestNavbar";
import Sidebar from "../../components/Sidebar";
import Content from "../../components/Content";
import RequestList from "./RequestList";
import CustomToaster from "../../components/CustomToaster";
import AdminDatasetUserrequest from "./AdminUserDataset";
import "../../styles/RequestList.css";
import { Modal, Header } from "semantic-ui-react";

import {
  getDatasetRequestList,
  requestUserDatasetListSuccess,
  approveAllDatasetRequest,
  denyAllDatasetRequest,
  requestApproveDatasetListSuccess,
  requestDenyDatasetListSuccess,
} from "../../actions/dataConsoleAction";

const index = ({ pageID, title }) => {
  const [toggleBtn, setToggleBtn] = useState(false);
  const toggle = () => setToggleBtn((val) => !val);
  const isMounted = useRef(true);
  const dispatch = useDispatch();
  const { userIdParam, userNameParam } = useParams();
  const [navTitle, setnavTitle] = useState("Admin Console");
  const [NavbarCollapse, setNavbarCollapse] = useState(true);
  const [openUserAdd, setOpenUserAdd] = useState(false);
  const [usersCount, setUsersCount] = useState(0);
  const [datasetCount, setDatasetCount] = useState(0);
  const [toasterVisible, setToasterVisible] = useState(false);
  const [toasterMessage, setToasterMessage] = useState("");
  const [toasterAppearance, setToasterAppearance] = useState("success");
  const [DatasetRequestedData, setDatasetRequestedData] = useState([]);
  const { requestDatasetData, requestDatasetStatus } = useSelector(
    (state) => state.requestDatasetList || {}
  );
  const { approvedDatasetData, approvedDatasetStatus } = useSelector(
    (state) => state.approvedRequestDataset || {}
  );
  const { deniedDatasetData, deniedDatasetStatus } = useSelector(
    (state) => state.deniedRequestDataset || {}
  );
  const [singleRequestFlag, setSingleRequestFlag] = useState(false);
  const [openConfirmationBox, setopenConfirmationBox] = useState(false);
  const [confirmationBoxTitle, setConfirmationBoxTitle] = useState("");
  const [confirmationBoxDiscription, setConfirmationBoxDiscription] =
    useState("");
  const [requestApiUserId, setRequestApiUserId] = useState("");
  const [requestApiDatasetIds, setRequestApiDatasetIds] = useState({});
  const [requestApiCall, setRequestApiCall] = useState("");
  const [openConfirmationBoxSingle, setopenConfirmationBoxSingle] =
    useState(false);
  const [confirmationBoxTitleSingle, setConfirmationBoxTitleSingle] =
    useState("");
  const [
    confirmationBoxDiscriptionSingle,
    setConfirmationBoxDiscriptionSingle,
  ] = useState("");
  const [requestApiUserIdSingle, setRequestApiUserIdSingle] = useState("");
  const [requestApiDatasetIdsSingle, setRequestApiDatasetIdsSingle] = useState(
    {}
  );
  const [requestApiCallSingle, setRequestApiCallSingle] = useState("");

  useEffect(() => {
    setnavTitle(title);
  }, [title]);

  useEffect(() => {
    if (isMounted.current) {
      isMounted.current = false;
      dispatch(getDatasetRequestList());
      dispatch(requestUserDatasetListSuccess([]));
      sessionStorage.removeItem("filterIds");
    }
  }, [isMounted, dispatch]);

  useEffect(() => {
    if (requestDatasetStatus === 200) {
      setDatasetRequestedData(requestDatasetData);
      handleSendUsersCount(requestDatasetData.length);
    } else if (requestDatasetStatus === 400) {
      setDatasetRequestedData([]);
    }
  }, [requestDatasetData, requestDatasetStatus]);

  useEffect(() => {
    if (approvedDatasetStatus === 200) {
      showToaster("Approved successfully", "success");
      dispatch(requestApproveDatasetListSuccess([]));
      dispatch(getDatasetRequestList());
      setSingleRequestFlag(true);
    } else if (approvedDatasetStatus === 404) {
      dispatch(requestApproveDatasetListSuccess([]));
      showToaster("Failed to approve", "error");
      setSingleRequestFlag(true);
    }
  }, [approvedDatasetData, approvedDatasetStatus]);

  useEffect(() => {
    if (deniedDatasetStatus === 200) {
      showToaster("Denied successfully", "success");
      dispatch(requestDenyDatasetListSuccess([]));
      dispatch(getDatasetRequestList());
      setSingleRequestFlag(true);
    } else if (deniedDatasetStatus === 404) {
      dispatch(requestDenyDatasetListSuccess([]));
      showToaster("Failed to deny", "error");
      setSingleRequestFlag(true);
    }
  }, [deniedDatasetData, deniedDatasetStatus]);

  const handleCloseButtonClick = () => {
    setToggleBtn(false); // Set toggleBtn to false
  };

  const handleOpenUserAdd = () => {
    setOpenUserAdd(true);
  };

  const handleSendUsersCount = (count) => {
    setUsersCount(count);
  };

  const handleSendDatasetCount = (count) => {
    setDatasetCount(count);
  };

  const showToaster = (message, appearance) => {
    setToasterVisible(true);
    setToasterMessage(message);
    setToasterAppearance(appearance);
  };

  const closeToaster = () => {
    setToasterVisible(false);
  };

  const handleDeny = (data) => {
    const userId = data.userId;
    const filterIds = data.datasets.map((dataset) => dataset.datasetId);
    const datasetIds = {
      datasets: filterIds,
    };
    setopenConfirmationBox(true);
    setConfirmationBoxTitle("Deny All");
    setConfirmationBoxDiscription(
      `Are you sure you want to deny all dataset requests for ${data.userName}?`
    );
    setRequestApiUserId(userId);
    setRequestApiDatasetIds(datasetIds);
    setRequestApiCall("deny");
  };

  const handleApprove = (data) => {
    const userId = data.userId;
    const filterIds = data.datasets.map((dataset) => dataset.datasetId);
    const datasetIds = {
      datasets: filterIds,
    };
    setopenConfirmationBox(true);
    setConfirmationBoxTitle("Approve All");
    setConfirmationBoxDiscription(
      `Are you sure you want to approve all dataset requests for ${data.userName}?`
    );
    setRequestApiUserId(userId);
    setRequestApiDatasetIds(datasetIds);
    setRequestApiCall("approve");
  };

  const handleSingleDeny = (data) => {
    const userId = userIdParam;
    const datasetIds = {
      datasets: [data.datasetId],
    };
    setopenConfirmationBoxSingle(true);
    setConfirmationBoxTitleSingle("Deny");
    setConfirmationBoxDiscriptionSingle(
      `Are you sure you want to deny  dataset requests for ${data.datasetName}?`
    );
    setRequestApiUserIdSingle(userId);
    setRequestApiDatasetIdsSingle(datasetIds);
    setRequestApiCallSingle("deny");
  };

  const handleSingleApprove = (data) => {
    const userId = userIdParam;
    const datasetIds = {
      datasets: [data.datasetId],
    };
    setopenConfirmationBoxSingle(true);
    setConfirmationBoxTitleSingle("Approve");
    setConfirmationBoxDiscriptionSingle(
      `Are you sure you want to approve  dataset requests for ${data.datasetName}?`
    );
    setRequestApiUserIdSingle(userId);
    setRequestApiDatasetIdsSingle(datasetIds);
    setRequestApiCallSingle("approve");
  };

  const handleApproveNav = () => {
    const filterIds = JSON.parse(sessionStorage.getItem("filterIds"));
    const datasetIds = {
      datasets: filterIds,
    };
    setopenConfirmationBox(true);
    setConfirmationBoxTitle("Approve All");
    setConfirmationBoxDiscription(
      `Are you sure you want to approve all dataset requests for ${sessionStorage.getItem(
        "requestusername"
      )}?`
    );
    setRequestApiUserId(userIdParam);
    setRequestApiDatasetIds(datasetIds);
    setRequestApiCall("approve");
  };

  const handleDenyNav = () => {
    const filterIds = JSON.parse(sessionStorage.getItem("filterIds"));
    const datasetIds = {
      datasets: filterIds,
    };
    setopenConfirmationBox(true);
    setConfirmationBoxTitle("Deny All");
    setConfirmationBoxDiscription(
      `Are you sure you want to deny all dataset requests for ${sessionStorage.getItem(
        "requestusername"
      )}?`
    );
    setRequestApiUserId(userIdParam);
    setRequestApiDatasetIds(datasetIds);
    setRequestApiCall("deny");
  };

  const actionRequestDataset = () => {
    if (requestApiCall === "approve") {
      dispatch(
        approveAllDatasetRequest(requestApiUserId, requestApiDatasetIds)
      );
    } else {
      dispatch(denyAllDatasetRequest(requestApiUserId, requestApiDatasetIds));
    }
    setopenConfirmationBox(false);
    setConfirmationBoxTitle("");
    setConfirmationBoxDiscription("");
    setRequestApiUserId("");
    setRequestApiDatasetIds({});
    setRequestApiCall("");
  };

  const actionRequestDatasetSingle = () => {
    if (requestApiCallSingle === "approve") {
      dispatch(
        approveAllDatasetRequest(
          requestApiUserIdSingle,
          requestApiDatasetIdsSingle
        )
      );
    } else {
      dispatch(
        denyAllDatasetRequest(
          requestApiUserIdSingle,
          requestApiDatasetIdsSingle
        )
      );
    }
    setopenConfirmationBoxSingle(false);
    setConfirmationBoxTitleSingle("");
    setConfirmationBoxDiscriptionSingle("");
    setRequestApiUserIdSingle("");
    setRequestApiDatasetIdsSingle({});
    setRequestApiCallSingle("");
  };

  const handleCloseConfirmationBox = () => {
    setopenConfirmationBox(false);
  };

  const handleCloseConfirmationBoxSingle = () => {
    setopenConfirmationBoxSingle(false);
  };

  return (
    <div className="top-wrapper">
      <Sidebar
        toggleBtn={toggleBtn}
        onCloseButtonClick={handleCloseButtonClick}
        activeMenu="Admin Console"
      />
      <RequestNavbar
        setToggle={toggle}
        handleOpenUserAdd={handleOpenUserAdd}
        showUsersCount={usersCount}
        showDatasetCount={datasetCount}
        navTitle={navTitle}
        type={pageID}
        NavbarCollapse={NavbarCollapse}
        handleApproveAllDatasetRequest={handleApproveNav}
        handleDenyAllDatasetRequest={handleDenyNav}
      />
      <Content toggleBtn={toggleBtn}>
        <div className="dataconsole-responsvive-body">
          {toasterVisible && (
            <CustomToaster
              message={toasterMessage}
              duration={3000}
              onClose={closeToaster}
              position="right-top"
              appearance={toasterAppearance}
            />
          )}
          {pageID === "dataset_request" ? (
            <RequestList
              openUserAdd={openUserAdd}
              handleCloseUserAdd={() => setOpenUserAdd(false)}
              showToaster={showToaster}
              DatasetRequestedData={DatasetRequestedData}
              handleApprove={handleApprove}
              handleDeny={handleDeny}
            />
          ) : pageID === "user_dataset_requests" ? (
            <AdminDatasetUserrequest
              openUserAdd={openUserAdd}
              handleCloseUserAdd={() => setOpenUserAdd(false)}
              handleSendDatasetCount={handleSendDatasetCount}
              showToaster={showToaster}
              handleApprove={handleSingleApprove}
              handleDeny={handleSingleDeny}
              singleRequestFlag={singleRequestFlag}
              changeSingleRequestFlag={() => setSingleRequestFlag(false)}
            />
          ) : (
            { pageID }
          )}
        </div>
      </Content>

      <Modal
        open={openConfirmationBox}
        onClose={handleCloseConfirmationBox}
        size="tiny"
        className="add-document-model deletePopup"
      >
        <Modal.Content>
          <Header as="h3">{confirmationBoxTitle}</Header>

          <p>{confirmationBoxDiscription}</p>
        </Modal.Content>
        <Modal.Actions>
          <button
            className="cancel-btn"
            onClick={handleCloseConfirmationBox}
            data-cy="cancel-dataset-confirmation-box"
          >
            Cancel
          </button>
          <button
            className={requestApiCall == "approve" ? "add-btn" : "add-btn"}
            onClick={actionRequestDataset}
            data-cy="action-dataset-confirm-box"
          >
            {confirmationBoxTitle}
          </button>
        </Modal.Actions>
      </Modal>

      <Modal
        open={openConfirmationBoxSingle}
        onClose={handleCloseConfirmationBoxSingle}
        size="tiny"
        className="add-document-model deletePopup"
      >
        <Modal.Content>
          <Header as="h3">{confirmationBoxTitleSingle}</Header>

          <p>{confirmationBoxDiscriptionSingle}</p>
        </Modal.Content>
        <Modal.Actions>
          <button
            className="cancel-btn"
            onClick={handleCloseConfirmationBoxSingle}
            data-cy="cancel-dataset-confirmation-box"
          >
            Cancel
          </button>
          <button
            className={
              requestApiCallSingle == "approve" ? "add-btn" : "add-btn"
            }
            onClick={actionRequestDatasetSingle}
            data-cy="action-dataset-confirm-box"
          >
            {confirmationBoxTitleSingle}
          </button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default index;
